export default {
	getById(id, cb, ecb = null) {
		this.http
			.get(`/report/getById/${id}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getByIds(ids, cb, ecb, config) {
		this.http
			.get(`/report/getByIds/${ids}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	search(params, cb, ecb) {
		this.http
			.get('/report/search', {
				params
			})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	update(form, cb, ecb) {
		this.http
			.post('/report/update', form)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	status(id, to, cb, ecb) {
		this.http
			.get(`/report/status/${id}/${to}`, {})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	generate(id, params, cb, ecb) {
		this.http
			.get(`/report/generate/${id}`, {
				params
			})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	sql(id, ps, cb, ecb) {
		this.http
			.get(`/report/sql/${id}?${ps}`, {})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getChartById(id, cb, ecb = null) {
		this.http
			.get(`/report/getChartById/${id}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getChartData(id, params, cb, ecb) {
		this.http
			.get(`/report/getChartData/${id}`, {
				params
			})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	searchChart(params, cb, ecb) {
		this.http
			.get('/report/searchChart', {
				params
			})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	updateChart(form, cb, ecb) {
		this.http
			.post('/report/updateChart', form)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	removeChart(id, cb, ecb) {
		this.http
			.get(`/report/removeChart/${id}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getParameters(reportid, cb, ecb) {
		this.http
			.get(`/report/getParameters/${reportid}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	removeParameter(id, cb, ecb) {
		this.http
			.get(`/report/removeParameter/${id}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	updateParameter(form, cb, ecb) {
		this.http
			.post(`/report/updateParameter`, form)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getColumns(reportid, cb, ecb) {
		this.http
			.get(`/report/getColumns/${reportid}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	removeColumn(id, cb, ecb) {
		this.http
			.get(`/report/removeColumn/${id}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	updateColumn(form, cb, ecb) {
		this.http
			.post(`/report/updateColumn`, form)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	}
}
